import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DownloadAppDialogComponent } from './download-app-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [
    DownloadAppDialogComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule
  ]
})
export class DownloadAppDialogModule { }
